edgeIndex